import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import { whyCards } from "../mock";

const WhyCard = ({ card }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="bg-[#181818] border border-[#2a2a2a] hover:border-[#e8a13a]/60 transition-all duration-500 group">
      <div className="overflow-hidden aspect-square">
        <img
          src={card.image}
          alt={card.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>
      <div className="p-6">
        <h3 className="font-display text-2xl text-[#e8a13a] mb-4">{card.title}</h3>
        <p className="text-[#d5c9a8] leading-relaxed text-sm">
          {expanded ? card.full : card.short}
        </p>
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-4 text-[#e8a13a] hover:text-[#f5f1e8] text-xs tracking-widest font-semibold transition-colors"
        >
          {expanded ? "SHOW LESS" : "SHOW MORE"}
        </button>
      </div>
    </div>
  );
};

const Why = () => {
  return (
    <div>
      <PageHeader
        title="What's So Special About Brains On Tap?"
        subtitle="The story, the mission, the approach, and the humans behind it."
      />
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyCards.map((card) => (
            <WhyCard key={card.title} card={card} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Why;
